.bf{overflow:hidden;}